import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { ILandingTelegramAuthFunnelRow } from '@/entities/landing.entity';
import { formatRateFraction, telegramAuthFunnelStepLabel } from '@/entities/landing-telegram-auth-funnel';
import { ShieldCheckIcon } from 'lucide-react';

interface LandingTelegramAuthFunnelChartProps {
	funnel: ILandingTelegramAuthFunnelRow[];
}

export default function LandingTelegramAuthFunnelChart({ funnel }: LandingTelegramAuthFunnelChartProps) {
	const baseline = funnel[0]?.count ?? 0;

	return (
		<Card className='gap-0 py-0 shadow-sm overflow-hidden'>
			<CardHeader className='border-b px-4 py-3'>
				<div className='flex items-center gap-2'>
					<div className='rounded-lg bg-chart-4/15 p-1.5'>
						<ShieldCheckIcon className='text-chart-4' size={16} />
					</div>
					<CardTitle className='text-sm'>Воронка TG авторизации</CardTitle>
				</div>
			</CardHeader>
			<CardContent className='px-4 py-3'>
				{baseline === 0 ? (
					<p className='text-sm text-muted-foreground py-6 text-center'>Нет стартов TG auth за период</p>
				) : (
					<div className='grid gap-2'>
						{funnel.map(row => (
							<div key={row.name} className='grid gap-1'>
								<div className='flex items-center justify-between gap-2 text-xs'>
									<span className='truncate'>{telegramAuthFunnelStepLabel(row.name)}</span>
									<span className='shrink-0 text-muted-foreground'>
										{row.count.toLocaleString('ru-RU')} · {formatRateFraction(row.rateFromStart)} от старта
									</span>
								</div>
								<div className='h-2 rounded-full bg-muted overflow-hidden'>
									<div
										className='h-full bg-chart-4 transition-all'
										style={{ width: `${Math.min(100, Math.round(row.rateFromStart * 100))}%` }}
									/>
								</div>
							</div>
						))}
					</div>
				)}
			</CardContent>
		</Card>
	);
}
